import React, { FC, ReactElement } from 'react'
import { Upload, Typography, Progress } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import { FileUploaderProps } from './types'
import { useFileUpload } from './useFileUpload'
import { AttachmentList } from './AttachmentList'
import styles from './styles.module.scss'
import { MESSAGES } from './constants'

export const FileUploader: FC<FileUploaderProps> = ({
  presignedPostPath,
  confirmPath,
  multiple = false,
  fileList,
  currentUserId,
  onUploadComplete,
  onRemove,
  onDownload
}): ReactElement => {
  const { uploadingFiles, uploadErrors, handleUpload } = useFileUpload({
    presignedPostPath,
    confirmPath,
    onUploadComplete
  })

  return (
    <>
      <Upload.Dragger multiple={multiple} customRequest={handleUpload} showUploadList={false}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">{MESSAGES.DRAGGER_TEXT}</p>
        <p className="ant-upload-hint">{MESSAGES.DRAGGER_HINT}</p>
      </Upload.Dragger>

      {uploadingFiles.length > 0 && (
        <div className={styles.uploadingList}>
          {uploadingFiles.map((file) => (
            <div key={file.uid} className={styles.uploadingCard}>
              <Typography.Text>{file.name}</Typography.Text>
              <Progress status="active" percent={file.percent} size="small" className={styles.progressBar} />
            </div>
          ))}
        </div>
      )}

      {uploadErrors.length > 0 && (
        <div className={styles.errorList}>
          {uploadErrors.map((error, i) => (
            <Typography.Text key={i} type="danger">
              <span dangerouslySetInnerHTML={{ __html: error }} />
            </Typography.Text>
          ))}
        </div>
      )}

      <AttachmentList
        attachments={fileList ?? []}
        currentUserId={currentUserId}
        onDownload={onDownload}
        onRemove={onRemove}
      />
    </>
  )
}

export default FileUploader
